var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Social / YouTube 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "account-overview",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "youtube-icon",
    transform: "translate(-371.000000, -404.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-/-YouTube-2",
    transform: "translate(371.000000, 404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Social-/-YouTube"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0700099,7.99898936 C16.6540239,7.99986395 23.5538691,8.02041682 25.3248408,8.50340909 C26.3490446,8.77856833 27.1592357,9.58875941 27.4343949,10.6129632 C27.8929936,12.3083888 27.947318,15.6588126 27.9534051,16.2539687 L27.9537611,16.4372704 C27.949971,17.0346088 27.9082803,20.3964027 27.4496815,22.0779314 C27.1745223,23.1021352 26.3643312,23.9123263 25.3401274,24.1874855 C23.6872205,24.6382783 17.5664949,24.686235 16.2829194,24.6913368 L15.8088004,24.6913368 C14.5252248,24.686235 8.40449925,24.6382783 6.75159236,24.1874855 C5.72738854,23.9123263 4.91719745,23.1021352 4.64203822,22.0779314 C4.18343949,20.3825058 4.1417487,17.032082 4.13795863,16.4369259 L4.13794714,16.2539802 C4.14162236,15.6589389 4.1820498,12.3097785 4.62675159,10.6282499 C4.90191083,9.60404603 5.71210191,8.79385495 6.73630573,8.51869572 C8.58598726,8.01423712 16.0305732,7.99895049 16.0305732,7.99895049 Z M13.6611465,12.7683772 L13.6611465,19.9225174 L19.8369427,16.3454473 L13.6611465,12.7683772 Z",
    id: "Youtube"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.f88bed95.svg";
export { ForwardRef as ReactComponent };